import { Component } from 'preact'
import $ from 'jquery'
import Header from '../header'
import IdeationList from './IdeationList'
import IdeationAddEdit from './IdeationAddEdit'
import Modal from '../../components/reactModal'
import ConfirmationModal from '../ui-components/ConfirmationModal'

class IdeationContainer extends Component {
  constructor () {
    super()
    this.state = {
      list: [],
      newIdeation: {
        name: '',
        bgColor: null,
        textColor: '#fff'
      },
      editableIdeationData: {},
      showModal: false,
      showConfirmation: false,
      isLoading: false,
      showError: false,
      successMessage: ''
    }

    this.endpoints = {
      getIdeations: '/settings/ideation/_getstatuses',
      setIdeation: '/settings/ideation/updateStatus',
      deleteIdeation: '/settings/ideation/deleteStatus'
    }

    this.enableModal = this.enableModal.bind(this)
    this.saveIdeation = this.saveIdeation.bind(this)
    this.updateIdeation = this.updateIdeation.bind(this)
    this.shouldDeleteIdeation = this.shouldDeleteIdeation.bind(this)
    this.deleteIdeation = this.deleteIdeation.bind(this)
  }

  componentDidMount () {
    $.get(this.endpoints.getIdeations).then(function (list) {
      if (!list.length) return
      list.forEach((item) => {
        item.bgColor = `#${item.bgColor}`
        item.textColor = `#${item.textColor}`
      })
      this.setState({ list, newIdeation: Object.assign({}, this.state.newIdeation, { bgColor: list[0].bgColor }) })
    }.bind(this))
  }

  saveIdeation (xhr = new window.XMLHttpRequest()) {
    let newData = Object.assign({}, this.state.editableIdeationData, {
      bgColor: this.state.editableIdeationData.bgColor.substr(1),
      textColor: this.state.editableIdeationData.textColor.substr(1)
    })

    this.setState({ isLoading: true, showError: false })
    xhr.onreadystatechange = (evt) => {
      if (xhr.readyState === 4) {
        if (evt.target.status >= 200 && evt.target.status < 400) {
          let updatedList = this.state.list
          updatedList[this.state.editableIdeationData.index] = Object.assign({}, this.state.editableIdeationData, JSON.parse(evt.target.response))
          this.setState({ list: updatedList, showModal: false, isLoading: false, successMessage: newData.id ? 'All changes saved!' : 'A new ideation is added successfully!' })
        } else {
          this.setState({ isLoading: false, showError: true })
        }
      }
    }
    xhr.open('POST', this.endpoints.setIdeation, true)
    xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')
    xhr.setRequestHeader('X-Csrf-Token', document.getElementById('csrftoken').value)
    xhr.send(JSON.stringify(newData))
  }

  enableModal (item, idx) {
    this.setState({ editableIdeationData: Object.assign({}, item, { index: idx }), showModal: true, successMessage: '' })
  }

  updateIdeation (newData) {
    this.setState({ editableIdeationData: newData })
  }

  shouldDeleteIdeation (idx) {
    this.setState({ showConfirmation: true, deleteItem: idx })
  }

  deleteIdeation (e, xhr = new window.XMLHttpRequest()) {
    this.setState({ isLoading: true, showError: false })

    const idx = this.state.deleteItem
    let updatedList = this.state.list.slice()
    updatedList.splice(idx, 1)

    if (idx <= this.state.list.length) {
      xhr.onreadystatechange = (evt) => {
        if (xhr.readyState === 4) {
          if (evt.target.status >= 200 && evt.target.status < 400) {
            this.setState({ list: updatedList, showConfirmation: false, isLoading: false, successMessage: 'An ideation status is deleted' })
          } else {
            this.setState({ isLoading: false, showError: true })
          }
        }
      }
      xhr.open('POST', this.endpoints.deleteIdeation, true)
      xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')
      xhr.setRequestHeader('X-Csrf-Token', document.getElementById('csrftoken').value)
      xhr.send(JSON.stringify({ id: this.state.list[idx].id }))
    } else {
      this.setState({ list: updatedList, showConfirmation: false })
    }
  }

  componentDidUpdate () {
    if (this.state.successMessage) {
      setTimeout(() => this.setState({ successMessage: '' }), 5000)
    }
  }

  render (props, state) {
    const colors = state.list.reduce((allColors, item) => { if (allColors.indexOf(item.bgColor) === -1) { allColors.push(item.bgColor) } return allColors }, [])

    return (
      <div className='ideation-page_container'>
        <Header title={'Ideation Status'} disableCancelButton disableSaveButton />
        {
          state.successMessage ? (
            <div className='alert alert-success'>
              {state.successMessage}
            </div>
          ) : null
        }
        <IdeationList deleteCallback={this.shouldDeleteIdeation} list={state.list} colors={colors} openEditIdeationModal={this.enableModal} />
        <div className='ideation-add-trigger-button'>
          <button className='btn btn-primary' onClick={() => this.enableModal(this.state.newIdeation, state.list.length)}>Add new status</button>
        </div>
        <Modal isOpen={state.showModal} onClose={() => this.setState({ showModal: false, showError: false })}>
          <IdeationAddEdit
            title={state.editableIdeationData.index === state.list.length ? 'Add new status' : 'Edit status'}
            data={state.editableIdeationData}
            colors={colors}
            onCallback={this.updateIdeation}
            cancelCallback={() => { this.setState({ showModal: false, showError: false }) }}
            isLoading={state.isLoading}
            showError={state.showError}
            saveCallback={this.saveIdeation}
          />
        </Modal>
        <ConfirmationModal
          isLoading={state.isLoading}
          showError={state.showError}
          enableModal={state.showConfirmation}
          title={`Delete this ideation status '${state.list[state.deleteItem] && state.list[state.deleteItem].name}'?`}
          message={'All ideas with this status will lose their status.'}
          onClose={() => { this.setState({ showConfirmation: false, showError: false }) }}
          buttons={[
            {
              text: 'Delete',
              callback: this.deleteIdeation,
              class: 'btn btn-danger',
              showLoading: true
            },
            {
              text: 'Cancel',
              callback: () => { this.setState({ showConfirmation: false, showError: false }) },
              class: 'btn btn-default',
              showLoading: false
            }
          ]}
        />
      </div>
    )
  }
}

export default IdeationContainer
